import { render } from "./TwoFactorQR.vue?vue&type=template&id=1605c266&ts=true"
import script from "./TwoFactorQR.vue?vue&type=script&lang=ts"
export * from "./TwoFactorQR.vue?vue&type=script&lang=ts"

import "./TwoFactorQR.vue?vue&type=style&index=0&id=1605c266&lang=scss"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__